// extracted by mini-css-extract-plugin
module.exports = {"component":"article-block_component__25JZh","content":"article-block_content__2uaPZ","title":"article-block_title__3n204"};